import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mantenimiento-error',
    templateUrl: './mantenimiento-error.component.html',
    styleUrls: ['./mantenimiento-error.component.scss'],
    standalone: false
})
export class MantenimientoErrorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
